import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import appointmentReducer from './store/Reducers/Appointment'
import { SnackbarProvider } from 'notistack';
import 'react-toastify/dist/ReactToastify.css';
import register from "./registerServiceWorker";


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  appointment: appointmentReducer,
})

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <SnackbarProvider maxSnack={1}>
      <Provider store={store}>
        <App />
        <ToastContainer theme='colored' />
      </Provider>
    </SnackbarProvider>
  </>
);

register();
